declare namespace $ {

	export class $mol_svg_circle extends $mol_svg {
		radius( ): string
		pos_x( ): string
		pos_y( ): string
		dom_name( ): string
		pos( ): readonly(any)[]
		attr( ): ({ 
			'r': ReturnType< $mol_svg_circle['radius'] >,
			'cx': ReturnType< $mol_svg_circle['pos_x'] >,
			'cy': ReturnType< $mol_svg_circle['pos_y'] >,
		})  & ReturnType< $mol_svg['attr'] >
	}
	
}

//# sourceMappingURL=circle.view.tree.d.ts.map